import { IS_DEBUG } from "../../config";
import { useAuth } from "./useAuth";

export default function usePermissions() {

  const {
    role,
    isAdmin,
  } = useAuth();

  return {
    canMinerPorts: isAdmin,
    canManagementTags: isAdmin,
    canManagementMinerProfiles: isAdmin,
    canPlanList: isAdmin,
    canMinerSpeedNotofications: true,
    canSwitchRole: true,
    canAccountEmailAndTelergam: IS_DEBUG,
  };
}